import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import BlockProductsCarousel from "../blocks/BlockProductsCarousel";
import { dealsBelow7000Api } from "../../api/dealsBelow7000";
import "./dealsBelow7000.css";

export default function DealsBelow7000Home() {
  const [data, setData] = useState(null);
  const [failed, setFailed] = useState(false);
  const [retry, setRetry] = useState(0);
  useEffect(() => {
    const controller = new AbortController();
    setFailed(false);
    dealsBelow7000Api.home(controller.signal).then(result => {
      if (!controller.signal.aborted) setData(result);
    }).catch(error => { if (!controller.signal.aborted) setFailed(true); });
    return () => controller.abort();
  }, [retry]);
  if (failed) return <section className="container deals-below-7000-home"><p role="status">Unable to load Deals below 7000 AED. <button type="button" className="btn btn-sm btn-outline-primary" onClick={() => setRetry(value => value + 1)}>Retry</button></p></section>;
  if (!data || !data.visible || !data.products.length) return null;
  return <section className="deals-below-7000-home" aria-label={data.title}>
    <BlockProductsCarousel title={data.title} subtitle={data.subtitle} layout="grid-4" products={data.products} />
    <div className="container deals-below-7000-home__more"><Link className="btn btn-primary" to="/deals-below-7000">View More <span aria-hidden="true">→</span></Link></div>
  </section>;
}
